<template>
  <section class="section container pt-0">
    <purchases-datatable :module_settings="module_settings" />
  </section>
</template>

<script>
import { get_configuration, error_message } from "@/utils";
import PurchasesDatatable from "./purchases_datatable/Index.vue";

export default {
  name: "PurchaseIndex",
  components: { PurchasesDatatable },
  data() {
    return {
      module_settings: {},
    };
  },
  methods: {},
  mounted() {},
  created() {
    let v = this;
    get_configuration(this)
      .then((conf) => {
        v.module_settings = conf;
      })
      .catch((error) => {
        error_message(error);
      });
  },
};
</script>

<style scoped></style>
